import { render, staticRenderFns } from "./plain.vue?vue&type=template&id=7f83792c&scoped=true&"
import script from "./plain.vue?vue&type=script&lang=js&"
export * from "./plain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f83792c",
  null
  
)

export default component.exports